<div class="container-fluid">
  <h1
    style="
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
        Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
      text-align: center;
    "
  >
    Contact Us
  </h1>
  <h3>Do you want to enjoy our service ?</h3>
  <p>Please, complete the next form</p>

  <form
    class="row g-2 needs-validation"
    [formGroup]="contactForm"
    (ngSubmit)="onSubmit()"
    novalidate
  >
    <div class="col-md-6">
      <label for="firstname" class="form-label">Name: </label>
      <input
        type="text"
        class="form-control"
        id="firstname"
        name="firstname"
        placeholder="Introduce your name"
        formControlName="firstname"
      />
      <div
        *ngIf="!firstname?.valid && (firstname?.dirty || firstname?.touched)"
      >
        <div class="alert alert-danger" [hidden]="!firstname.errors.required">El nombre es requerido</div>
      </div>
    </div>

    <div class="col-md-6">
      <label for="lastname" class="form-label">Lastname: </label>
      <input
        type="text"
        class="form-control"
        id="lastname"
        name="lastname"
        placeholder="Introduce your lastname"
        formControlName="lastname"
      />
      <div *ngIf="!lastname.valid && (lastname.dirty || lastname.touched)">
        <div class="alert alert-danger" [hidden]="!lastname.errors.required">El apellido es requerido</div>
      </div>
    </div>

    <div class="col-md-12">
      <label for="email" class="form-label">Email: </label>
      <input
        type="text"
        class="form-control"
        id="email"
        aria-describedby="emailFeedback"
        name="email"
        placeholder="Introduce your email"
        formControlName="email"
      />
      <div *ngIf="!email.valid && (email.dirty || email.touched)">
        <div class="alert alert-danger" [hidden]="!email.errors.required">Email es requerido</div>
        <div class="alert alert-danger" [hidden]="!email.errors.email">Email inválido</div>
      </div>
    </div>

    <div class="container-fluid">
      <div
        *ngIf="contactForm.valid"
        class="alert alert-success d-flex align-items-center"
        role="alert"
      >
        <div><strong> ¡Welcome aboard, {{contactForm.value.firstname}} ! </strong></div>
      </div>
    </div>

    <div class="col-12">
      <button
        [disabled]="!contactForm.valid"
        class="btn btn-primary"
        type="submit"
      >
        Send
      </button>
    </div>
  </form>
</div>
